__webpack_require__.p = "/Tenzies-Game/";